import { useState, useEffect, useRef } from 'react';
import '../styles/Home.css';

const ROLES = ['ML Engineer', 'Software Engineer','Data Scientist', 'Product Manager'];
const PREFIX = 'I am a ';
const TYPE_DELAY = 70;
const BACKSPACE_DELAY = 40;
const PAUSE_AFTER_TYPE = 1200;
const PAUSE_AFTER_DELETE = 400;

const Home = () => {
  const [displayText, setDisplayText] = useState(PREFIX);
  const roleIndex = useRef(0);
  const charIndex = useRef(0);
  const phase = useRef('typing'); 

  useEffect(() => {
    const tick = () => {
      const role = ROLES[roleIndex.current];

      if (phase.current === 'typing') {
        if (charIndex.current < role.length) {
          charIndex.current++;
          setDisplayText(PREFIX + role.slice(0, charIndex.current));
          return TYPE_DELAY;
        }
        phase.current = 'pausing';
        return PAUSE_AFTER_TYPE;
      }

      if (phase.current === 'pausing') {
        phase.current = 'deleting';
        return 0;
      }

      if (phase.current === 'deleting') {
        if (charIndex.current > 0) {
          charIndex.current--;
          setDisplayText(PREFIX + role.slice(0, charIndex.current));
          return BACKSPACE_DELAY;
        }
        roleIndex.current = (roleIndex.current + 1) % ROLES.length;
        phase.current = 'pauseDelete';
        return PAUSE_AFTER_DELETE;
      }

      if (phase.current === 'pauseDelete') {
        phase.current = 'typing';
        return 0;
      }

      return TYPE_DELAY;
    };

    let timeoutId;
    const schedule = () => {
      const delay = tick();
      timeoutId = setTimeout(schedule, delay);
    };
    schedule();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <section className="home-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Hello, my name is <span className="mobile-break"></span><span className="name-highlight">Man Teng</span>
        </h1>
        <h2 className="typing-text">
          {PREFIX}<span className="role-highlight">{displayText.slice(PREFIX.length)}</span><span className="typing-cursor"></span>
        </h2>
        <p className="hero-description">
          A results-oriented 3rd Year Information Systems undergraduate in NUS, specialising in Al/ML. My goal is to apply my technical skills in Al and system designs to solve large scale, high impact problems.
        </p>
        <div className="hero-contact">
          Scroll to get to know more about me
        </div>
      </div>
    </section>
  );
};

export default Home;